import styled from "styled-components";
import { HeadLine3 } from "../../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 1200px;
`;

export const HeadWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  margin-top: 16px;
`;

export const PageTitle = styled(HeadLine3)`
  color: ${({ theme }) => theme.palette[900]};
`;

export const NavWrapper = styled.div`
  margin-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.palette[300]};
`;

export const TabContent = styled.div`
  padding: 24px 0;
`;
